

'use strict';

var picturefill = require('picturefill');
var jquery = require('jquery');
var svgInliner = require('svg-inliner-util');
var attachFastClick = require('imports?define=>false!fastclick');

var helpers = require('./utilities/helpers');

var NameRoulette = require('./name-roulette/nameRoulette');
var SiteTransitionManager = require('./siteTransitionManager');


var App = function() {

    // console.log('app started...');

    helpers.bindPolyfill();
    helpers.requestAnimationFramePolyfill();

    this.configureNameRoulette();

    this.siteTransitionManager = new SiteTransitionManager( this.onSiteTransitionsEnd.bind(this) );

    this.configureElems();
    this.configureEvents();

    this.loadSvgStore('svg-store/store-main.svg');

};



App.prototype = {

    constructor: App,

    configureElems: function() {
        this.$headerLogo = $('[data-header-logo]');
    },


    /***
     * load SVG store and inject it into the DOM
     *
     */
    loadSvgStore: function(url) {
        if (window.ASSET_CACHE_BUSTER) {
            url = url + '?' + window.ASSET_CACHE_BUSTER;
        }

        svgInliner.loadStore({
            url: url,
            success: this.onSvgStoreLoadSuccess.bind(this, url),
            error: this.onSvgStoreLoadError.bind(this, url)
        });
    },


    onSvgStoreLoadError: function(url) {
        console.log('svg store load error', url);
        this.playAnimations();
    },


    onSvgStoreLoadSuccess: function(url) {
        console.log('svg store loaded successfully', url);
        svgInliner.process('.js-inline-svg');

        this.siteTransitionManager.play();
    },
    

    /***
     * name roulette
     *
     */
    configureNameRoulette: function() {
        
        var $nameRouletteElem = $('[data-name-roulette]');

        if ($nameRouletteElem.length === 0) {
            return;
        }

        this.nameRoulette = new NameRoulette( $nameRouletteElem, this.onRouletteSpin.bind(this) );

    },


    onRouletteSpin: function() {
        this.playHeaderLogoJig();
    },

    
    /*
     * site on transition end callback
     *
     */
    onSiteTransitionsEnd: function() {
        var nameRoulette = this.nameRoulette;

        window.setTimeout(function() {
            nameRoulette.spinAll();
        }, 500);
    },


    /***
     * play header logo 'jig' animation
     *
     */
    playHeaderLogoJig: function() {
        var $headerLogo = this.$headerLogo;
        $headerLogo.removeClass('play-jig');

        window.setTimeout(function() {
            $headerLogo.addClass('play-jig');
        }, 50);
    },


    /*
     * events
     *
     */
    configureEvents: function() {
        this.$headerLogo.on( 'click', this.onHeaderLogoClick.bind(this) );
    },

    onHeaderLogoClick: function() {
        this.nameRoulette.spinAll();
        this.playHeaderLogoJig();
    }


};




// kick off the app
var onDOMReady = function() {
    // console.log('app - DOM ready for action!');
    attachFastClick(document.body);
    var app = new App();
};

if (document.readyState === 'interactive' || document.readyState === 'complete') {
    onDOMReady();
} else {
    document.addEventListener('DOMContentLoaded', onDOMReady, false);
}












/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/src/app.js
 ** module id = 0
 ** module chunks = 0
 **/